import React, { useState } from "react";
import SubmitReqPreSugestedPrice from "../../components/submitReqPreSugestedPrice/submitReqPreSugestedPrice.component";
import SubmitReqPreToggleBtn from "../../components/submitReqPreToggleBtn/SubmitReqPreToggleBtn.component";
import { setMapLevel } from "../../redux/map/map.actions";
import {
  SubmitReqPreFormStyled,
  ReciverContainer,
  ReciverInput,
  AddOtherDestinationBtn,
  AddOtherDestinationContainer,
  MoreInfoStylrd,
} from "./SubmitReqPreForm.styles";
import LoadInfo from "../loadInfo/loadInfo.component";
import RadioBtns from "../radioBtns/radioBtns.component";
import Auction from "../auction/auction.component";
import Calender from "../calender/calender.component";
import { useDispatch, useSelector } from "react-redux";
import { toEnglishNum, toPersianNum } from "../../assets/utils";
import {
  setCalenderBargiryShow,
  setIsTwoWay,
  setPaymentInDestination,
  setReceiverInfo,
  // setNewRequestType,
} from "../../redux/newRequest/newRequest.actions";
import {
  selectNewRequestCalenderBargiry_show,
  selectNewRequestIsTwoWay,
  selectNewRequestPaymentInDestination,
  selectNewRequestBargiryDate,
  selectReceiverInfo,
  selectVehicleType,
  selectAlertNotifShow,
  // selectNewRequestType,
} from "../../redux/newRequest/newRequest.selectors";
import { selectPreReqTypeOfLoad } from "../../redux/preReq/preReq.selectors";
import ToggleTabs from "../toggleTabs/toggleTabs.component";
import OtherDestinationInfo from "../otherDestinationInfo/otherDestinationInfo.component";
import HeavyReqPreForm from "../heavyReqPreForm/heavyReqPreForm.component";
// import { TimePicker } from "antd";

const SubmitReqPreForm = () => {
  const [receiverInfoObj, setReceiverInfoObj] = useState({
    phone: "",
    name: "",
  });
  const [show, setShow] = useState(true);
  // const [submitType, setSubmitType] = useState("tavafoghi");
  const dispatch = useDispatch();
  const showCalender = useSelector(selectNewRequestCalenderBargiry_show);
  const selectedDate = useSelector(selectNewRequestBargiryDate);
  const vehicleType = useSelector(selectVehicleType);
  const showAlert = useSelector(selectAlertNotifShow);
  // const newRequestType = useSelector(selectNewRequestType);
  const typeOfLoad = useSelector(selectPreReqTypeOfLoad);
  if (receiverInfoObj.phone.length === 11 && receiverInfoObj.name) {
    dispatch(setReceiverInfo(receiverInfoObj));
  }
  const AddOtherDestination = () => {
    let counter = 1;
    dispatch(setMapLevel(`1.0${counter}`));
    counter++;
  };
  const isInstant = typeOfLoad.type === "instant";
  const onTimeClick = () => {
    dispatch(setCalenderBargiryShow(true));
  };

  return (
    <SubmitReqPreFormStyled>
      <span className={`${!showAlert ? "d-none" : ""}`}>
        {/* <SubmitReqPreToggleBtn /> */}
        <p className="my-2">
          {isInstant ? (
            <span>
              درخواست شما ثبت و به تمام رانندگان در محدوده شما ارسال
              می‌شود.درخواست شما ثبت و به تمام رانندگان در محدوده شما ارسال
              می‌شود.
            </span>
          ) : (
            <span>
              درخواست بار شما در سیستم اعلان بار ثبت شده. و رانندگان پیشنهاد
              قیمت خود را به شما اعلام خواهند کرد.
            </span>
          )}
        </p>
        <SubmitReqPreSugestedPrice isInstant={isInstant} />
        <ToggleTabs
          small
          getTab={useSelector(selectNewRequestIsTwoWay)}
          setTab={() => dispatch(setIsTwoWay())}
          className="mt-2"
        >
          <button data-n={0}>یک طرفه</button>
          <button data-n={1}>رفت و برگشت</button>
        </ToggleTabs>
        <ToggleTabs
          small
          getTab={useSelector(selectNewRequestPaymentInDestination)}
          setTab={() => dispatch(setPaymentInDestination())}
          className="mt-2"
        >
          <button data-n={0}>پرداخت با خودم</button>
          <button data-n={1}>پرداخت با گیرنده</button>
        </ToggleTabs>
        <ReciverContainer>
          <ReciverInput
            type="text"
            value={receiverInfoObj.name}
            onChange={(e) =>
              setReceiverInfoObj({ ...receiverInfoObj, name: e.target.value })
            }
            placeholder="نام تحویل گیرنده"
          />
          <ReciverInput
            maxLength={11}
            minLength={10}
            type="text"
            value={toPersianNum(receiverInfoObj.phone)}
            onChange={(e) =>
              setReceiverInfoObj({
                ...receiverInfoObj,
                phone: toEnglishNum(e.target.value),
              })
            }
            placeholder="تلفن تحویل گیرنده"
          />
        </ReciverContainer>
        <LoadInfo dark />

        <RadioBtns dark bimehOnly={isInstant} />
        {vehicleType === "heavy" && (
          <MoreInfoStylrd onClick={() => setShow(false)}>
            جزئیات بیشتر
          </MoreInfoStylrd>
        )}
        <div
          className={`${show ? "d-none" : ""}`}
          style={{ height: "55vh" }}
          // onClick={() => setShow(!show)}
        >
          <HeavyReqPreForm
            selectedDate={selectedDate}
            onTimeClick={onTimeClick}
            setShow={setShow}
          />
        </div>
        <OtherDestinationInfo />
        {isInstant && (
          <AddOtherDestinationContainer>
            <AddOtherDestinationBtn
              onClick={AddOtherDestination}
              className="w-100 mt-2"
            >
              افزودن مقصد جدید
            </AddOtherDestinationBtn>
          </AddOtherDestinationContainer>
        )}
        {!isInstant && (
          <div>
            <AddOtherDestinationContainer>
              {/* <Auction second /> */}
              <AddOtherDestinationBtn
                onClick={AddOtherDestination}
                className="w-100 mt-2"
              >
                افزودن مقصد جدید
              </AddOtherDestinationBtn>
            </AddOtherDestinationContainer>

            <div
              className="mt-4 p-2 position-relative"
              style={{ backgroundColor: "#eaebed", borderRadius: "10px" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                className="svg"
              >
                <g id="Group_1124" transform="translate(.244)">
                  <g
                    id="Rectangle_1923"
                    fill="none"
                    stroke="#2a2e43"
                    transform="translate(-.244)"
                  >
                    <rect width="12" height="12" stroke="none" rx="4" />
                    <rect width="11" height="11" x=".5" y=".5" rx="3.5" />
                  </g>
                  <path
                    id="Line_38"
                    d="M0 4L0 0"
                    className="cls-2"
                    transform="translate(5.756 2)"
                  />
                  <path
                    id="Line_39"
                    d="M0 0L2.5 1.5"
                    className="cls-2"
                    transform="translate(6 6)"
                  />
                </g>
              </svg>
              <button onClick={onTimeClick} className="w-100 font-weight-bold">
                {selectedDate.value
                  ? toPersianNum(selectedDate.value)
                  : "زمان بندی درخواست"}
              </button>
            </div>
          </div>
        )}
        {showCalender && (
          <div className="submit-req-pre__calender">
            <Calender />
          </div>
        )}
        {/* <LoadTiming second /> */}
      </span>
    </SubmitReqPreFormStyled>
  );
};

export default SubmitReqPreForm;
